module.exports = __webpack_public_path__ + "static/media/estudioDeTatuagemEPiercing.1245db20.svg";